module.exports = __webpack_public_path__ + "a51174c490a36b3eae9e9b5abe959c15.png";